import {useCallback, useEffect, useState} from "react";

import {getMedicalOrganizations} from "../../../services/medicalOrganization";
import {getOrganizationVaccines} from "../../../services/organizationVaccine";
import {MedicalOrganizationVaccine} from "../../../types/MedicalOrganizationVaccine";
import {mergeMedicalOrganizationVaccines} from "../model/mergeMedicalOrganizationVaccines";

export const useMedicalOrganizationVaccines = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [medicalOrganizationVaccines, setMedicalOrganizationVaccines] = useState<MedicalOrganizationVaccine[]>([]);

  const fetchMedicalOrganizationVaccines = useCallback(async () => {
    setLoading(true);
    const tempMedicalOrganizations = await getMedicalOrganizations();
    const tempOrganizationVaccines = await getOrganizationVaccines();

    const merged = mergeMedicalOrganizationVaccines({
      medicalOrganizations: tempMedicalOrganizations,
      organizationVaccines: tempOrganizationVaccines,
    });
    setMedicalOrganizationVaccines(merged);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchMedicalOrganizationVaccines();
  }, [fetchMedicalOrganizationVaccines]);

  return {
    loading,
    medicalOrganizationVaccines,
    fetchMedicalOrganizationVaccines,
  };
};
